module.exports = __webpack_public_path__ + "static/broadcaster_section2-dd08576d1044ac6d3712ed82a1b148c5.png";